export default "__VITE_ASSET__995403c6__"